import { TrendingUp } from 'lucide-react'
import { TabsContent } from '../ui/tabs'
import { Input } from '../ui/input'
import { SuggestedProduct } from '../../services/purchases.service'

interface SuggestedOrdersTabProps {
  suggestedProducts: SuggestedProduct[]
  suggestedFilters: { dateFrom: string; dateTo: string }
  setSuggestedFilters: (filters: { dateFrom: string; dateTo: string }) => void
}

export function SuggestedOrdersTab({
  suggestedProducts,
  suggestedFilters,
  setSuggestedFilters,
}: SuggestedOrdersTabProps) {
  return (
    <TabsContent value="suggested" className="space-y-4">
      <div className="rounded-lg border border-primary/20 bg-primary/10 p-4">
        <div className="flex items-start gap-3">
          <TrendingUp className="mt-0.5 h-5 w-5 text-primary" />
          <div>
            <h3 className="font-medium text-primary/90">
              Pedidos basados en rotación
            </h3>
            <p className="mt-1 text-sm text-primary">
              Estos productos requieren reabastecimiento según su velocidad de
              venta
            </p>
          </div>
        </div>
      </div>

      {/* Filtros de Fecha */}
      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <h3 className="mb-4 font-medium text-slate-900">Filtros</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700">
              Fecha Inicio
            </label>
            <Input
              type="date"
              value={suggestedFilters.dateFrom}
              onChange={(e) =>
                setSuggestedFilters({
                  ...suggestedFilters,
                  dateFrom: e.target.value,
                })
              }
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700">
              Fecha Fin
            </label>
            <Input
              type="date"
              value={suggestedFilters.dateTo}
              onChange={(e) =>
                setSuggestedFilters({
                  ...suggestedFilters,
                  dateTo: e.target.value,
                })
              }
            />
          </div>
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
        <table className="w-full">
          <thead className="border-b border-slate-200 bg-slate-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Producto
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Stock Actual
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Venta Promedio
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Días Rest.
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Cant. Sugerida
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase">
                Proveedor
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {suggestedProducts.map((product) => (
              <tr key={product.id} className="hover:bg-slate-50">
                <td className="px-6 py-4 font-medium text-slate-900">
                  {product.name}
                </td>
                <td className="px-6 py-4">
                  <span
                    className={`font-medium ${product.currentStock < 20 ? 'text-red-600' : 'text-slate-900'}`}
                  >
                    {product.currentStock}
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-700">
                  {product.avgSales}/día
                </td>
                <td className="px-6 py-4">
                  <span
                    className={`font-medium ${product.daysRemaining < 1 ? 'text-red-600' : 'text-slate-900'}`}
                  >
                    {product.daysRemaining.toFixed(1)}
                  </span>
                </td>
                <td className="px-6 py-4 font-semibold text-primary">
                  {product.suggested}
                </td>
                <td className="px-6 py-4 text-sm text-slate-700">
                  {product.supplier}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TabsContent>
  )
}
